import { render, staticRenderFns } from "./AutomaticPaymentCreateForm.vue?vue&type=template&id=672924ea&scoped=true&"
import script from "./AutomaticPaymentCreateForm.vue?vue&type=script&lang=ts&"
export * from "./AutomaticPaymentCreateForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672924ea",
  null
  
)

export default component.exports